import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { WeekType } from "./types";

// for getting week endings from billing group data.  This may be changed later.
export const getWeekEndingsFromWeekData = (WeekData: WeekType[]) => {
    let week = WeekData;
    //TODO: Make sure to fix this before going live so that it will get todays date not this one
    let today = new Date();
    let weekEndingDates: string[] = [];
    for (let i = 0; i < week.length; i++) {
        const unformattedDateTime = new Date(week[i].WeekEnding);
        if (unformattedDateTime < today) {
            const formattedDateTime = (unformattedDateTime.getMonth() + 1).toString().padStart(2, '0')
                + '/' + unformattedDateTime.getDate().toString().padStart(2, '0')
                + '/' + unformattedDateTime.getFullYear();
            weekEndingDates.push(formattedDateTime);
        }
    }
    weekEndingDates = sortWeekEndings(weekEndingDates);
    return weekEndingDates;
}

// sorting the weekendings 
export const sortWeekEndings = (dateStringArrayToSort: string[]) => {
    // This sort assumes MM-DD-YYYY format for array of date strings
    dateStringArrayToSort.sort(function (a, b) {
        let aComps = a.split("/");
        let bComps = b.split("/");
        //@ts-ignore
        let aDate = new Date(aComps[2], aComps[0], aComps[1]);
        //@ts-ignore
        let bDate = new Date(bComps[2], bComps[0], bComps[1]);
        return bDate.getTime() - aDate.getTime();
    })
    return dateStringArrayToSort
}

// **************************************  Selection of invoice group or profit center and week ending
export const checkforNullAndSort = (arrayToSort: { label: string, value: string }[]) => {
    arrayToSort.sort((a, b) => {
        if (a?.label !== null && b?.label !== null) {
            return a?.label.localeCompare(b?.label)
        } else {
            return -1;
        }
    })
    arrayToSort.forEach(function (group, idx, arr) {
        if (group.label === null) {
            arr.splice(idx, 1);
        }
    });
}


export const handleInvoiceGroupOrProfitCenterChange = (e: any, setter: Function) => {
    setter(e);
}

export const handleWeekEndChange = (e: any, setter: Function) => {
    setter(e.label);
}

export const handleInvoiceOrProfitCenterCheck = (e: any, setter: Function) => {
    setter(e.target.value)
}

// ****************************** Search Functions *******************************************************
export function debounce(func: any, wait: any, immediate: any) {
    var timeout: any;
    return function () {
        //@ts-ignore
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export function handleSearch(searchItem: string, setInvoiceProgress: Function, makeIPsEditable: Function) {
    let invoiceProgressUrl = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getinvoiceprogressbyinvoicenumber/${searchItem}`, AxiosConfig.configValue("min"));
    let invoicePaymentUrl = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getinvoicepayment/${searchItem}`, AxiosConfig.configValue("min"));
    Axios.all([invoiceProgressUrl, invoicePaymentUrl])
        .then((res) => {
            //console.log("Search got ", res[0].data, res[1].data );
            setInvoiceProgress(makeIPsEditable(res[0].data));
            if (res[0].data.length > 0) {
                //console.log(res[0].data.length)
            }
        })
        .catch((err) => {

        })
}

//?? This will probably get used for the invoice payments and or the Show Past Due summary.
export function handleSearchPayments(searchItem: string, setInvoiceProgress: Function, setInvoicePayments: Function, setShowSearch: Function) {
    let invoiceProgressUrl = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getinvoiceprogressbyinvoicenumber/${searchItem}`, AxiosConfig.configValue("min"));
    let invoicePaymentUrl = Axios.get(`${process.env.REACT_APP_API_URL}/api/ip/getinvoicepayment/${searchItem}`, AxiosConfig.configValue("min"));
    Axios.all([invoiceProgressUrl, invoicePaymentUrl])
        .then((res) => {
            //console.log("Search got ", res[0].data, res[1].data );
            setInvoiceProgress(res[0].data);
            setInvoicePayments(res[1].data);
            if (res[0].data.length > 0) {
                setShowSearch(true);
                //console.log(res[0].data.length)
            }
        })
        .catch((err) => {

        })
}



